import { render } from "./RightNavbar.vue?vue&type=template&id=480e83ba&scoped=true"
import script from "./RightNavbar.vue?vue&type=script&lang=js"
export * from "./RightNavbar.vue?vue&type=script&lang=js"

import "./RightNavbar.vue?vue&type=style&index=0&id=480e83ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480e83ba"]])

export default __exports__